export default __webpack_public_path__ + "static/media/IMG-20241005-WA0045.14fb1bc4.jpg";